import { getSalesDataSourceWebPage } from 'commons/service/bank/salesData'
import { SalesDataSourceWebPage, SalesDataSourceWebPagePayload } from 'commons/types/DTO/bank/salesDataSourceWebPage'
import { Keys, ReadHook, useStateManager } from 'state-manager'

const getHandler = (payload?: SalesDataSourceWebPagePayload) => (): Promise<SalesDataSourceWebPage> =>
  getSalesDataSourceWebPage(payload)

export const useGetSalesDataSourceWebPage: ReadHook<SalesDataSourceWebPage, SalesDataSourceWebPagePayload> = (opts) =>
  useStateManager().use(Keys.SalesData.Details(opts), getHandler(opts))
